export const TEAM_STICKER_TOKEN_SOURCE = "(:grid_[a-z0-9_]+:)";

export const TEAM_STICKERS = Object.freeze([
  { id: "smile", token: ":grid_smile:", label: "Smile", src: "/assets/team-stickers/grid-smile.png" },
  { id: "wink", token: ":grid_wink:", label: "Wink", src: "/assets/team-stickers/grid-wink.png" },
  { id: "heart-eyes", token: ":grid_heart_eyes:", label: "Heart eyes", src: "/assets/team-stickers/grid-heart-eyes.png" },
  { id: "surprised", token: ":grid_surprised:", label: "Surprised", src: "/assets/team-stickers/grid-surprised.png" },
  { id: "laugh", token: ":grid_laugh:", label: "Laugh", src: "/assets/team-stickers/grid-laugh.png" },
  { id: "sad", token: ":grid_sad:", label: "Sad", src: "/assets/team-stickers/grid-sad.png" },
  { id: "cry", token: ":grid_cry:", label: "Cry", src: "/assets/team-stickers/grid-cry.png" },
  { id: "cool", token: ":grid_cool:", label: "Cool", src: "/assets/team-stickers/grid-cool.png" },
  { id: "coffee", token: ":grid_coffee:", label: "Coffee", src: "/assets/team-stickers/grid-coffee.png" },
  { id: "sleepy", token: ":grid_sleepy:", label: "Sleepy", src: "/assets/team-stickers/grid-sleepy.png" },
  { id: "strong", token: ":grid_strong:", label: "Strong", src: "/assets/team-stickers/grid-strong.png" },
  { id: "inspect", token: ":grid_inspect:", label: "Inspect", src: "/assets/team-stickers/grid-inspect.png" },
  { id: "blush", token: ":grid_blush:", label: "Blush", src: "/assets/team-stickers/grid-blush.png" },
  { id: "warning", token: ":grid_warning:", label: "Warning", src: "/assets/team-stickers/grid-warning.png" },
  { id: "angry", token: ":grid_angry:", label: "Angry", src: "/assets/team-stickers/grid-angry.png" },
  { id: "party", token: ":grid_party:", label: "Party", src: "/assets/team-stickers/grid-party.png" },
  { id: "cold", token: ":grid_cold:", label: "Cold", src: "/assets/team-stickers/grid-cold.png" },
  { id: "love", token: ":grid_love:", label: "Love", src: "/assets/team-stickers/grid-love.png" },
  { id: "crowned", token: ":grid_crowned:", label: "Crowned", src: "/assets/team-stickers/grid-crowned.png" },
  { id: "peace", token: ":grid_peace:", label: "Peace", src: "/assets/team-stickers/grid-peace.png" },
]);

export const TEAM_STICKERS_BY_TOKEN = Object.freeze(
  TEAM_STICKERS.reduce((acc, sticker) => {
    acc[sticker.token] = sticker;
    return acc;
  }, {})
);

export function splitTeamMessageBody(body) {
  const value = String(body || "");
  const tokenPattern = new RegExp(TEAM_STICKER_TOKEN_SOURCE, "g");

  return value
    .split(tokenPattern)
    .filter((part) => part.length > 0)
    .map((part) => {
      const sticker = TEAM_STICKERS_BY_TOKEN[part];
      return sticker
        ? { type: "sticker", sticker }
        : { type: "text", text: part };
    });
}

export function isStickerOnlyTeamMessage(body) {
  const value = String(body || "");
  const tokenPattern = new RegExp(TEAM_STICKER_TOKEN_SOURCE, "g");
  const segments = splitTeamMessageBody(value);

  return (
    segments.length > 0 &&
    segments.every(
      (segment) => segment.type === "sticker" || segment.text.trim().length === 0
    ) &&
    value.replace(tokenPattern, "").trim().length === 0
  );
}
